import { configureAndSendPageTag } from '../../domain/analytics/analytics.utils'
import { setGeoentityFilterParameters, setGeoentityTabId } from '../geoentity/geoentitySlice'
import { setNavigationDone } from '../history/historySlice'

export const sendPageTagOnNavigationDone =
  ({ getState }) =>
  next =>
  action => {
    if (action.type === setNavigationDone.type) {
      configureAndSendPageTag(action, getState())
    }

    return next(action)
  }

export const sendPageTagOnGeoentityTabChange =
  ({ getState }) =>
  next =>
  action => {
    const r = next(action)

    if (action.type === setGeoentityTabId.type) configureAndSendPageTag(undefined, getState())

    return r
  }

export const sendPageTagOnGeoentityFilterChange =
  ({ getState }) =>
  next =>
  action => {
    const n = next(action)
    if (action.type === setGeoentityFilterParameters.type) {
      configureAndSendPageTag(undefined, getState())
    }
    return n
  }

export default __SERVER__
  ? []
  : [sendPageTagOnNavigationDone, sendPageTagOnGeoentityTabChange, sendPageTagOnGeoentityFilterChange]
